import { defaultTo } from 'aa_common/front-end/helpers'
import { useWatch } from 'react-hook-form'

import { FIELD_NAMES } from '../validation'

export const useIsFullImpairment = () => {
  const isPartialImpair = useWatch<boolean>({
    name: FIELD_NAMES.is_partial_impairment,
  })

  return {
    isFullImpairment: !defaultTo(isPartialImpair, false),
  }
}
